import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ala_user_token");
    if (!token) { setLoading(false); return; }
    fetchMe(token).finally(() => setLoading(false));
  }, []);

  const fetchMe = async () => {
    try {
      const res = await api.get("/users/me", { headers: { Authorization: `Bearer ${localStorage.getItem("ala_user_token")}` } });
      setUser(res.data);
    } catch {
      localStorage.removeItem("ala_user_token");
      setUser(null);
    }
  };

  const register = async (data) => {
    const res = await api.post("/users/register", data);
    localStorage.setItem("ala_user_token", res.data.token);
    setUser({ id: res.data.user_id, nombre: res.data.nombre, correo: res.data.username, telefono: data.telefono || "", direccion: data.direccion || "", rut: data.rut || "" });
    return res.data;
  };

  const login = async (correo, password) => {
    const res = await api.post("/users/login", { correo, password });
    localStorage.setItem("ala_user_token", res.data.token);
    await fetchMe();
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("ala_user_token");
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, register, login, logout, loading, refresh: fetchMe }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
